import Highcharts from 'highcharts';

export const figure41 = { 
chart: {
zoomType: 'xy',
animation: false,
marginTop: 40,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height:'400px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
stacking: 'normal',
dataLabels: {
		     enabled: true,
		     formatter: function () {
// 'this.y' contains the data value of the point
				      return Highcharts.numberFormat(this.y,0) + '%'; // Format the value as percentage with 2 decimal places
			      },
	     },
	},
},

exporting: {
enabled: false
},


xAxis: [{
categories: [ 
	     "التسجيل المشترك للأراضي",
	     "موافقة الزوج على معاملات الأراضي",
	     "المساواة في الميراث للنساء والفتيات",
	     "الموارد المالية**",
	     "الحماية بموجب القانون العرفي*",
	     "المشاركة في إدارة الأراضي**",
],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 10,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px',
}
},
}],
yAxis: [{ // Primary yAxis
labels: {
//format: '{value}%',
enabled: false,		
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
gridLineWidth: 0,
floor: 0,
title: {
text: "",
style: {
color: Highcharts.getOptions().colors[1]
}
},
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
//headerFormat: '<div>{point.key}</div>',
valuePrefix: '%',
style: {
padding: 0
},
},
legend: {
enabled: false,
},

series: [
{
name: 'غير موجود',
valuePrefix: '%',
color: '#c00000',
marker: {
"symbol": 'square',
perc: '34%',
radius: 2
},	      
data: [ 66, 42, 42, 76, 49, 59 ]
},
{
name: 'موجود',
valuePrefix: '%',
color: '#5b9bd5',
marker: {
"symbol": 'square',
perc: '66%',
radius: 2
},	      		  
data: [ 34, 58, 58, 24, 51, 41 ]
},
]
}
